import util from '@/libs/util.js';
export default {
  methods: {
    handleMenuSelect: function handleMenuSelect(index, indexPath) {
      var paths = this.deepMainMenuIndex(this.aside, function (item) {
        return item.path === index;
      }); // console.log('indexPath',indexPath);
      // console.log('this.target',this.target);  

      if (/^d2-menu-empty-\d+$/.test(index) || index === undefined) {
        this.$message.warning('临时菜单');
      } else if (/^https:\/\/|http:\/\//.test(index)) {
        util.open(index);
      } else {
        console.log('paths', paths);

        if (paths[1].Target === "_self") {
          this.$router.push({
            path: index
          });
        } else if (paths[1].Target === "_blank") {
          this.$router.push({
            path: index
          });
          var routeData = this.$router.resolve({
            path: index
          });
          window.open(routeData.href, '_blank');
        }
      }
    }
  }
};